import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { IAppState } from '~/appstate';

export interface IMetaProductIsSelectByUmSettingWarningModalState {
	showMetaProductIsSelectByUmWarningModal: boolean;
	valueSelectedForIsSelectByUm: boolean | null;
}

export const initialState: IMetaProductIsSelectByUmSettingWarningModalState = {
	showMetaProductIsSelectByUmWarningModal: false,
	valueSelectedForIsSelectByUm: null,
};

export const open = createAsyncThunk<
	void,
	boolean,
	{ state: IAppState; rejectValue: string[] | Response }
>('addBySupcModal/openModal', async (isSelectByUm: boolean, { dispatch }) => {
	dispatch(
		metaProductIsSelectByUmSettingWarningModalSlice.actions.showMetaProductIsSelectByUmWarningModal(
			isSelectByUm
		)
	);
});

export const metaProductIsSelectByUmSettingWarningModalSlice = createSlice({
	name: 'metaProductPage/MetaProductIsSelectByUmWarningModal',
	initialState,
	reducers: {
		showMetaProductIsSelectByUmWarningModal: (state, action) => {
			state.showMetaProductIsSelectByUmWarningModal = true;
			state.valueSelectedForIsSelectByUm = action.payload;
		},
		hideMetaProductIsSelectByUmWarningModal: (state) => {
			state.showMetaProductIsSelectByUmWarningModal = false;
			state.valueSelectedForIsSelectByUm = null;
		},
	},
});

export const {
	showMetaProductIsSelectByUmWarningModal,
	hideMetaProductIsSelectByUmWarningModal,
} = metaProductIsSelectByUmSettingWarningModalSlice.actions;
